import React, { Suspense, useMemo, useRef } from "react";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "react-feather";
import Modal from "react-bootstrap/Modal";
import { useProductImageCarousel } from "../../Pregrine/ProductImageCarousel/useProductImageCarousel";
import classes from "./carousel.module.css";
import Thumbnail from "./thumbnail";
import Slider from "react-slick";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import "./carousel.css";
import { GoZoomIn } from "react-icons/go";
import "swiper/modules/navigation/navigation.min.css";
import { PiCubeFocusLight } from "react-icons/pi";
import swipeCore, {
  Navigation,
  Pagination,
  Scrollbar,
  Zoom,
  A11y,
} from "swiper";

swipeCore.use([Navigation, Zoom, Pagination, Scrollbar, A11y]);

const IMAGE_WIDTH = 640;
import placeholder from "../../assets/images/productPlaceholder.webp";
import { useSelector } from "react-redux";
import ShareButton from "../../components/ShareButton/ShareButton";
import { getFlagTextColor } from "../../utility/getFlagTextColor";
import { LazyLoadImage } from "react-lazy-load-image-component";
const ThreeDModal = React.lazy(() =>
  import("../../components/ThreeDModal/ThreeDModal")
);

const ProductImageCarousel = (props) => {
  const {
    images,
    zoom,
    setProductZoom,
    showThreeDModal,
    setShowThreeDModal,
    modelData,
    modelLoading,
    product,
    flagText,
  } = props;
  const { ConfigData } = useSelector((state) => state.homePageSlice);
  const productLink = `/product/${product.url_key}.html}`;
  const share_url = `${document.location.origin}${productLink}`;

  const handleClose = () => {
    setProductZoom(false);
    document.body.classList.remove("noScroll");
  };

  const handleShow = (file) => {
    setProductZoom(true);
    document.body.classList.add("noScroll");
  };
  const sliderRef = useRef(null);
  const talonProps = useProductImageCarousel({
    images,
    imageWidth: IMAGE_WIDTH,
    sliderRef,
  });

  const {
    currentImage,
    activeItemIndex,
    altText,
    handleNext,
    handlePrevious,
    handleThumbnailClick,
  } = talonProps;

  const settings = {
    dots: false,
    arrows: false,
    autoplay: false,
    infinite: images && images.length > 4,
    speed: 50,
    slidesToShow: 4,
    slidesToScroll: 1,
  };

  const thumbnails = useMemo(
    () =>
      images?.map((item, index) => (
        <Thumbnail
          item={item}
          itemIndex={index}
          isActive={activeItemIndex === index}
          onClickHandler={handleThumbnailClick}
          ConfigData={ConfigData}
        />
      )),
    [activeItemIndex, handleThumbnailClick, images]
  );

  const threeDModal = (
    <Suspense fallback={null}>
      <ThreeDModal
        modelData={modelData}
        modelLoading={modelLoading}
        showThreeDModal={showThreeDModal}
        setShowThreeDModal={setShowThreeDModal}
      />
    </Suspense>
  );

  let image;

  image = (
    <section className={classes.imageContainer}>
      {threeDModal}
      <div className={classes.currentImage}>
        {flagText && flagText.toLowerCase() !== "na" ? (
          <div
            className={classes.ribbon}
            style={{
              borderImage: `conic-gradient(${getFlagTextColor(
                flagText
              )} 0 0) fill 0`,
            }}
          >
            {flagText}
          </div>
        ) : null}
        <div className={classes.shareWrapper}>
          <ShareButton product={product} shareUrl={share_url} />
        </div>
        {Object.keys(currentImage).length !== 0 &&
        currentImage.__typename === "ProductImage" ? (
          <div
            className={classes.zoom}
            onClick={() => {
              handleShow(currentImage);
            }}
          >
            <GoZoomIn size={24} />
          </div>
        ) : null}

        {Object.keys(currentImage).length !== 0 ? (
          currentImage.__typename === "ProductImage" ? (
            <LazyLoadImage
              src={currentImage?.url}
              alt={altText}
              placeholderSrc={placeholder}
              className={classes.mainImage}
            />
          ) : currentImage.url ? (
            <video
              src={currentImage.url}
              alt={currentImage.label}
              controls
            ></video>
          ) : (
            <img
              height={500}
              width={500}
              alt={altText}
              src={placeholder}
              fetchPriority="high"
            />
          )
        ) : (
          <img
            height={500}
            width={500}
            alt={altText}
            src={placeholder}
            fetchPriority="high"
          />
        )}
      </div>
      <div className={classes.modelBtnWrapper}>
        {!modelLoading && modelData?.getThreeDModel?.url ? (
          <button
            onClick={() => {
              setShowThreeDModal(true);
            }}
            className={classes.modelBtn}
            disabled={
              !modelLoading &&
              modelData &&
              modelData.getThreeDModel &&
              modelData.getThreeDModel.url
                ? false
                : true
            }
          >
            <PiCubeFocusLight size={24} />
          </button>
        ) : null}
      </div>
    </section>
  );

  const previousButton = <span>PreviousImage</span>;
  const nextButton = <span>NextImage</span>;

  const chevronClasses = { root: classes.chevron };

  return (
    <div className={classes.productcontainer_zoom}>
      <div className={classes.root}>
        <div className={classes.carouselContainer}>{image}</div>
        <div
          className={`${classes.productslidernew} d-sm-none d-md-none d-lg-block `}
        >
          {images?.length ? (
            <button
              className={classes.thumbnailPrevBtn}
              onClick={handlePrevious}
              aria-label={previousButton}
              type="button"
            >
              <ChevronLeftIcon classes={chevronClasses} width={20} />
            </button>
          ) : null}
          <div className={`${classes.thumbnailList} product-detail-carousel`}>
            <Slider ref={sliderRef} {...settings}>
              {thumbnails}
            </Slider>
          </div>
          {images?.length ? (
            <button
              className={classes.thumbnailNextBtn}
              onClick={handleNext}
              aria-label={nextButton}
              type="button"
            >
              <ChevronRightIcon classes={chevronClasses} width={20} />
            </button>
          ) : null}
        </div>
      </div>

      <Modal show={zoom} centered onHide={handleClose}>
        <Modal.Header closeButton>
          <h5>Product Zoom</h5>
        </Modal.Header>
        <Modal.Body>
          {zoom ? (
            <Suspense fallback={null}>
              <Swiper
                zoom={true}
                navigation={true}
                pagination={{ clickable: true }}
                loop={true}
              >
                <div className="container">
                  {images.map((image) => {
                    return (
                      <SwiperSlide>
                        <div className="swiper-zoom-container">
                          {image ? (
                            Object.keys(image).length !== 0 ? (
                              image.__typename === "ProductImage" ? (
                                image.url ? (
                                  <img
                                    height={400}
                                    width={400}
                                    src={image.url}
                                    alt={"image"}
                                  />
                                ) : (
                                  <img
                                    width={400}
                                    height={400}
                                    alt={altText}
                                    src={placeholder}
                                  />
                                )
                              ) : image.url ? (
                                <video
                                  src={image.url}
                                  alt={image.label}
                                  height={400}
                                  width={400}
                                  controls
                                ></video>
                              ) : (
                                <img
                                  height={400}
                                  width={400}
                                  alt={altText}
                                  src={placeholder}
                                />
                              )
                            ) : (
                              <img
                                height={400}
                                width={400}
                                alt={altText}
                                src={placeholder}
                              />
                            )
                          ) : null}
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </div>
              </Swiper>
            </Suspense>
          ) : null}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProductImageCarousel;
